import { Form, Root as Root$1 } from "../input/Input.js";
import "../input/index.js";
import { createContext, use, useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import * as SliderRadix from "@radix-ui/react-slider";
//#region src/slider/Slider.tsx
const SliderContext = createContext({
	min: void 0,
	max: void 0,
	value: [],
	defaultValue: void 0,
	orientation: "horizontal"
});
const useSliderContext = () => {
	return use(SliderContext);
};
const SliderRoot = ({ className, orientation = "horizontal", ...props }) => {
	const context = useMemo(() => ({
		min: props.min,
		max: props.max,
		value: props.value,
		defaultValue: props.defaultValue,
		orientation
	}), [
		props.min,
		props.max,
		props.value,
		props.defaultValue,
		orientation
	]);
	return /* @__PURE__ */ jsx(SliderContext, {
		value: context,
		children: /* @__PURE__ */ jsx(SliderRadix.Root, {
			orientation,
			className: twMerge("relative flex w-full touch-none items-center select-none", "data-[orientation=vertical]:h-full data-[orientation=vertical]:w-4 data-[orientation=vertical]:flex-col", "data-[orientation=horizontal]:h-4", className),
			...props
		})
	});
};
const SliderTrack = ({ className, ...props }) => /* @__PURE__ */ jsx(SliderRadix.Track, {
	className: twMerge("relative grow rounded-md bg-gray-300", "data-[orientation=horizontal]:h-2", "data-[orientation=vertical]:w-2", className),
	...props
});
const SliderRange = ({ className, ...props }) => /* @__PURE__ */ jsx(SliderRadix.Range, {
	className: twMerge("absolute rounded-full bg-blue-600 data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full", className),
	...props
});
const SliderThumb = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(SliderRadix.Thumb, {
		className: twMerge("block h-5 w-5 rounded-full bg-white shadow-md outline-hidden hover:bg-blue-100", "focus:ring-2 focus:ring-blue-500", className),
		...props
	});
};
const SliderValueIndicator = ({ className, variant = "primary", ...props }) => {
	const { orientation } = useSliderContext();
	return /* @__PURE__ */ jsx("span", {
		className: twMerge("absolute", orientation === "horizontal" && "left-1/2 -translate-x-1/2", orientation === "vertical" && "top-1/2 left-full -translate-y-1/2", orientation === "horizontal" && variant === "primary" && "top-full", orientation === "vertical" && variant === "primary" && "ml-2", variant === "secondary" && "rounded-lg border border-gray-300 bg-white p-2 text-sm shadow-lg", orientation === "horizontal" && variant === "secondary" && "bottom-full mb-2", orientation === "vertical" && variant === "secondary" && "left-full ml-2", className),
		...props
	});
};
const SliderInput = ({ inputProps, className, value, defaultValue, id, ...props }) => {
	const displayValue = formatDisplayValue(value ?? defaultValue);
	return /* @__PURE__ */ jsx(Root$1, {
		className: twMerge("w-36", className),
		...props,
		children: /* @__PURE__ */ jsx(Form, {
			readOnly: true,
			value: displayValue,
			id,
			...inputProps
		})
	});
};
const formatDisplayValue = (values) => {
	if (!values || values.length === 0) return "0";
	if (values.length === 1) return values[0].toString();
	return values.map((val) => val.toString()).join(" - ");
};
const Root = SliderRoot;
const Track = SliderTrack;
const Range = SliderRange;
const Thumb = SliderThumb;
const ValueIndicator = SliderValueIndicator;
const Input = SliderInput;
//#endregion
export { Input, Range, Root, SliderInput, SliderRange, SliderRoot, SliderThumb, SliderTrack, SliderValueIndicator, Thumb, Track, ValueIndicator, formatDisplayValue };
